import { CurrencyPipe } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { GetTransactionsType } from 'src/app/shared/enums/get-transactions-type';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { Transaccion } from '../../interfaces/transaccion.interface';
import { TransaccionService } from '../../services/transaccion.service';
import { WorkingAccountService } from '../../services/working-account.service';
import { DetalleCajeroComponent } from '../detalle-cajero/detalle-cajero.component';
@Component({
  selector: 'app-status-cajero',
  templateUrl: './status-cajero.component.html',
  styleUrls: ['./status-cajero.component.sass'],
})
export class StatusCajeroComponent implements OnDestroy {
  statusCajero: any[] = [];
  countryCode = ['VE', 'US', 'CL'];
  transacciones: Transaccion[] = [];

  displayedColumns: string[] = [
    'cajero',
    'banco',
    'moneda',
    'balanceSistema',
    'balance',
    'total',
    'necesarioOB',
    'necesarioMB',
  ];
  columns = [
    {
      columnDef: 'cajero',
      header: 'Cajero',
      cell: (element: any) =>
        `${element.cuenta.nombre} ${element.cuenta.apellidos}`,
      clickable: true,
    },
    {
      columnDef: 'banco',
      header: 'Banco',
      cell: (element: any) => `${element.cuenta.banco.nombre}`,
    },
    {
      columnDef: 'moneda',
      header: 'Moneda',
      cell: (element: any) => this.getCurrency(element.cuenta.banco.codigoPais),
    },
    {
      columnDef: 'balanceSistema',
      header: 'Balance en sistema',
      cell: (element: any) =>
        `${this.currencyPipe.transform(element.total, '$')}`,
    },
    {
      columnDef: 'balance',
      header: 'Balance restante en el sistema',
      cell: (element: any) =>
        `${this.currencyPipe.transform(
          element.total -
            (element.necesarioOb + element.fiatOb + element.necesarioMb),
          '$'
        )}`,
    },
    {
      columnDef: 'total',
      header: 'Total',
      cell: (element: any) =>
        `${this.currencyPipe.transform(
          element.necesarioOb + element.fiatOb + element.necesarioMb,
          '$'
        )}`,
    },
    {
      columnDef: 'fiatOB',
      header: 'Fiat OB',
      cell: (element: any) =>
        `${this.currencyPipe.transform(element.fiatOb, '$')}`,
    },
    {
      columnDef: 'necesarioOB',
      header: 'Necesario OB',
      cell: (element: any) =>
        `${this.currencyPipe.transform(element.necesarioOb, '$')}`,
    },
    {
      columnDef: 'necesarioMB',
      header: 'Necesario MB',
      cell: (element: any) =>
        `${this.currencyPipe.transform(element.necesarioMb, '$')}`,
    },
  ];
  dataSource: MatTableDataSource<any> | undefined;

  // Mobile accordion
  expandedCardId: number | null = null;

  paises: string[] = [];
  bancos: string[] = [];
  monedas: string[] = [];
  selectedPais: string = '';
  selectedBanco: string = '';
  selectedMoneda: string = '';

  private refreshInterval: any;

  constructor(
    private workingAccountService: WorkingAccountService,
    private spinner: SpinnerService,
    private currencyPipe: CurrencyPipe,
    private transactionService: TransaccionService,
    private dialog: MatDialog
  ) {
    this.loadData();
    this.startAutoRefresh();
  }

  ngOnDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

  startAutoRefresh() {
    this.refreshInterval = setInterval(() => {
      this.loadData();
    }, 180000);
  }

  onCajeroClick(element: any) {
    this.dialog.open(DetalleCajeroComponent, {
      width: '95vw',
      maxWidth: '1400px',
      height: '90vh',
      data: {
        cuenta_trabajo_id: element.cuenta.cuenta_trabajo_id,
        transacciones: this.transacciones,
        statusCajero: this.statusCajero,
      },
    });
  }
  async loadData() {
    const ref = this.spinner.start();

    const currentFilters = {
      pais: this.selectedPais,
      banco: this.selectedBanco,
      moneda: this.selectedMoneda,
    };

    this.statusCajero = await this.workingAccountService.getStatusCajero(
      this.countryCode
    );
    this.extractFilters();
    const bankType = false ? 'BINANCE' : undefined;
    const transaccionesResult = await this.transactionService.getAllTransactions(
      GetTransactionsType.ASSIGNED,
      bankType
    );
    this.transacciones = Array.isArray(transaccionesResult) ? transaccionesResult : (transaccionesResult as any)?.query ?? [];
    await this.calculateNecesarioValues();
    this.dataSource = new MatTableDataSource(this.statusCajero);

    if (currentFilters.pais || currentFilters.banco || currentFilters.moneda) {
      this.selectedPais = currentFilters.pais;
      this.selectedBanco = currentFilters.banco;
      this.selectedMoneda = currentFilters.moneda;
      this.applyFilters();
    }

    this.spinner.stop(ref);
  }

  async calculateNecesarioValues() {
    this.statusCajero.forEach((cajero) => {
      cajero.necesarioMb = 0;
      cajero.necesarioOb = 0;
    });

    this.transacciones.forEach((transaccion) => {
      if (transaccion.cuentaTrabajo && transaccion.cuentaBeneficiario) {
        const cajero = this.statusCajero.find(
          (c) => c.id === transaccion.cuentaTrabajo?.cuenta_trabajo_id
        );

        if (cajero) {
          const bancoBeneficiario = transaccion.cuentaBeneficiario.bancoID;
          const bancoTrabajo = transaccion.cuentaTrabajo.bancoID;

          if (bancoBeneficiario === bancoTrabajo) {
            cajero.necesarioMb += transaccion.totalMonedaDestino;
          } else {
            cajero.necesarioOb += transaccion.totalMonedaDestino;
          }
        }
      }
    });

    if (this.dataSource) {
      this.dataSource.data = [...this.statusCajero];
    }
  }

  getCurrency(codigoPais: string): string {
    switch (codigoPais) {
      case 'VE':
        return 'VES';
      case 'US':
        return 'USD';
      case 'CL':
        return 'CLP';
      default:
        return codigoPais;
    }
  }

  extractFilters() {
    const paisesSet = new Set<string>();
    const bancosSet = new Set<string>();
    const monedasSet = new Set<string>();

    this.statusCajero.forEach((item) => {
      if (item.cuenta?.banco?.codigoPais) {
        paisesSet.add(item.cuenta.banco.codigoPais);
        monedasSet.add(this.getCurrency(item.cuenta.banco.codigoPais));
      }
      if (item.cuenta?.banco?.nombre) {
        bancosSet.add(item.cuenta.banco.nombre);
      }
    });

    this.paises = Array.from(paisesSet).sort();
    this.bancos = Array.from(bancosSet).sort();
    this.monedas = Array.from(monedasSet).sort();
  }

  applyFilters() {
    if (!this.dataSource) return;

    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const filters = JSON.parse(filter);
      const paisMatch =
        !filters.pais || data.cuenta?.banco?.codigoPais === filters.pais;
      const bancoMatch =
        !filters.banco || data.cuenta?.banco?.nombre === filters.banco;
      const monedaMatch =
        !filters.moneda ||
        this.getCurrency(data.cuenta?.banco?.codigoPais) === filters.moneda;
      return paisMatch && bancoMatch && monedaMatch;
    };

    this.dataSource.filter = JSON.stringify({
      pais: this.selectedPais,
      banco: this.selectedBanco,
      moneda: this.selectedMoneda,
    });
  }

  toggleCard(id: number): void {
    this.expandedCardId = this.expandedCardId === id ? null : id;
  }

  clearFilters() {
    this.selectedPais = '';
    this.selectedBanco = '';
    this.selectedMoneda = '';
    this.applyFilters();
  }

  getBlinkingClass(element: any): string {
    const columnTotal = element.necesarioOb + element.necesarioMb;
    if (columnTotal === 0) {
      return '';
    }

    const total = element.total - (element.necesarioOb + element.necesarioMb);

    const moneda = this.getCurrency(element.cuenta?.banco?.codigoPais);

    let umbralAmarillo = 20000;

    if (moneda === 'USD') {
      umbralAmarillo = 1000;
    } else if (moneda === 'CLP') {
      umbralAmarillo = 500000;
    }

    if (total < 1) {
      return 'blinking-text';
    } else if (total < umbralAmarillo) {
      return 'blinking-text2';
    }
    return '';
  }
}
